import type { ReactNode } from 'react';
import { Separator } from '@/shared/ui/shadcn/separator';
import { SidebarTrigger } from '@/shared/ui/shadcn/sidebar';

export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2" />
      <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
        <div className="min-w-0">
          <h1 className="truncate text-sm font-semibold">{title}</h1>
          {description ? (
            <div className="flex min-w-0 items-center gap-1.5 truncate text-xs text-muted-foreground">
              {description}
            </div>
          ) : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  );
}
